import { carinaFontReset } from './styleHelper';

export function containerCss(theme) {
  return {
    ...carinaFontReset(theme),
    backgroundColor: 'transparent',
    boxSizing: 'border-box',
    position: 'relative',
    width: '100%'
  };
}

export function containerOpenCss(theme, isOpen) {
  if (!isOpen) return;

  return {
    boxShadow: `
        ${theme.depth.boxShadow.hard.xOffset}
        ${theme.depth.boxShadow.hard.yOffset}
        ${theme.depth.boxShadow.hard.blurRadius}
        ${theme.depth.boxShadow.hard.spreadRadius}
        ${theme.depth.boxShadow.hard.color}`,
    display: 'block'
  };
}

export function buttonCss({
  theme,
  variant,
  hasError = false,
  heading = false,
  isRtl = false
}) {
  /* eslint-disable */
  const borderColor = hasError
    ? theme.borderColor.danger.base
    : variant
    ? theme.borderColor[variant].base
    : theme.borderColor.base;
  const focusColor = hasError
    ? theme.backgroundColor.danger.fill.focus
    : variant
    ? theme.backgroundColor[variant].fill.focus
    : theme.backgroundColor.interactive.fill.focus;

  /* eslint-enable */

  const start = isRtl ? 'Right' : 'Left';
  const end = isRtl ? 'Left' : 'Right';

  return {
    ...carinaFontReset(theme),
    textAlign: isRtl ? 'right' : 'left',
    direction: isRtl ? 'rtl' : 'ltr',
    lineHeight: theme.font.lineHeight.base,
    appearance: 'none',
    backgroundColor: 'transparent',
    boxSizing: 'border-box',
    border: `1px solid ${borderColor}`,
    color: theme.font.color.base,
    cursor: heading ? 'default' : 'pointer',
    display: 'block',
    fill: theme.font.color.base,
    fontSize: theme.font.base.size.s,
    margin: 0,
    outline: 0,
    paddingTop: '0.5rem',
    [`padding${end}`]: '3rem',
    paddingBottom: '0.5rem',
    [`padding${start}`]: '1rem',
    position: 'relative',
    width: '100%',
    minHeight: '2.25rem',

    '&:focus': {
      boxShadow: `0 0 0 ${theme.size.border.focus}px ${focusColor}`
    },
    '&:disabled': {
      backgroundColor: theme.backgroundColor.disabled,
      borderColor: theme.borderColor.disabled,
      color: theme.font.color.disabled,
      fill: theme.backgroundColor.disabled,
      pointerEvents: 'none'
    },
    '&::-moz-focus-inner': {
      border: 0
    }
  };
}

export function placeholder(theme, isRtl) {
  return {
    color: theme.font.color.soft,
    textAlign: isRtl ? 'right' : 'left',
    direction: isRtl ? 'rtl' : 'ltr'
  };
}

export function iconCss(theme, isRtl = false) {
  return {
    pointerEvents: 'none',
    position: 'absolute',
    [isRtl ? 'left' : 'right']: '1rem',
    top: '9px'
  };
}
